export function intToChar(int: number, uppercase = true): string {
  const code = (uppercase ? 'A' : 'a').charCodeAt(0);
  return String.fromCharCode(code + int);
}
